"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DateFormatter = _interopRequireDefault(require("../../../../common/Formatters/DateFormatter"));
var _ActionsMenu = _interopRequireDefault(require("../../../ActionsMenu/ActionsMenu"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.project-preview {\n  width: 100%;\n  border-top: 1px solid #d4d4d4; }\n  .project-preview:last-child {\n    border-bottom: 1px solid #d4d4d4; }\n  .project-preview .bx--row {\n    min-height: 105px;\n    margin: 0; }\n    .project-preview .bx--row.without-name {\n      min-height: 80px; }\n    .project-preview .bx--row .preview {\n      position: relative;\n      display: flex;\n      flex: 1;\n      min-height: 100%; }\n      .project-preview .bx--row .preview .actions-toolbar {\n        height: 1.5rem; }\n        .project-preview .bx--row .preview .actions-toolbar .actions-menu {\n          position: absolute;\n          top: 0;\n          right: 0; }\n      .project-preview .bx--row .preview .project-preview-link {\n        text-decoration: none;\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap; }\n      .project-preview .bx--row .preview .texts {\n        padding-top: 24px; }\n        .project-preview .bx--row .preview .texts .name {\n          height: 26px;\n          display: block; }\n        .project-preview .bx--row .preview .texts h2 {\n          margin-bottom: 16px; }\n        .project-preview .bx--row .preview .texts .tags-group {\n          margin-bottom: 19px; }\n      .project-preview .bx--row .preview .tags {\n        padding-top: 57px; }\n        .project-preview .bx--row .preview .tags.without-name {\n          padding-top: 32px; }\n      .project-preview .bx--row .preview .date {\n        padding-top: 63px;\n        margin-bottom: 24px; }\n        .project-preview .bx--row .preview .date.without-name {\n          padding-top: 38px; }\n      @media (max-width: 1055px) {\n        .project-preview .bx--row .preview .date {\n          padding-top: 104px; }\n          .project-preview .bx--row .preview .date.without-name {\n            padding-top: 78px; }\n        .project-preview .bx--row .preview .logo .logo-spacing {\n          min-height: 130px; } }\n      @media (max-width: 671px) {\n        .project-preview .bx--row .preview {\n          flex-wrap: wrap; }\n        .project-preview .bx--row .preview .texts,\n        .project-preview .bx--row .preview .logo,\n        .project-preview .bx--row .preview .date {\n          padding-left: 0; }\n          .project-preview .bx--row .preview .texts .tags-group,\n          .project-preview .bx--row .preview .logo .tags-group,\n          .project-preview .bx--row .preview .date .tags-group {\n            margin-bottom: 16px; }\n        .project-preview .bx--row .preview .display-none {\n          display: none; }\n        .project-preview .bx--row .preview .date {\n          padding-top: 0; }\n          .project-preview .bx--row .preview .date.without-name {\n            padding-top: 0; } }\n";
  const fileName = "ProjectPreview_ProjectPreview";
  const element = document.querySelector("style[data-sass-component='ProjectPreview_ProjectPreview']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ProjectPreview = _ref => {
  let {
    title,
    tags,
    date,
    translate,
    logo,
    name,
    actions,
    Component,
    url
  } = _ref;
  const imageRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const image = imageRef.current;
    if (image) {
      image.decode().then(() => {
        const {
          height,
          width
        } = imageRef.current;
        if (height > width) {
          image.style.width = 'auto';
          image.style.height = '100%';
        } else {
          image.style.width = '100%';
          image.style.height = 'auto';
        }
      });
    }
  });
  const withoutNameClass = !name ? 'without-name' : '';
  const createClasses = () => {
    const classes = ['preview'];
    if (actions) {
      classes.push('with-actions');
    }
    return classes;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'project-preview'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `bx--row ${withoutNameClass}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: createClasses().join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'actions-toolbar'
  }, actions && /*#__PURE__*/_react.default.createElement(_ActionsMenu.default, {
    actions: actions,
    translate: translate,
    name: title
  })), /*#__PURE__*/_react.default.createElement(Component, {
    to: url,
    className: 'project-preview-link'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'bx--col-lg-6 bx--col-md-4 bx--col-sm-4 texts'
  }, name && /*#__PURE__*/_react.default.createElement("span", {
    className: 'name'
  }, name), /*#__PURE__*/_react.default.createElement("h2", null, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: `bx--col-lg-4 bx--col-md-0 bx--col-sm-0 tags ${withoutNameClass}`
  }, tags), /*#__PURE__*/_react.default.createElement("div", {
    className: `bx--col-lg-4 bx--col-md-2 bx--col-sm-4 date ${withoutNameClass}`
  }, _DateFormatter.default.format(date))))));
};
ProjectPreview.propTypes = {
  Component: _propTypes.default.elementType.isRequired,
  url: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  tags: _propTypes.default.object.isRequired,
  date: _propTypes.default.string.isRequired,
  translate: _propTypes.default.func.isRequired,
  logo: _propTypes.default.string,
  name: _propTypes.default.string,
  published: _propTypes.default.bool,
  actions: _propTypes.default.object,
  onClickUnpublished: _propTypes.default.func
};
var _default = exports.default = ProjectPreview;